module.exports = "pegasus/assets/blocks/image-3-theme6.png";